import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-search-cpf',
  templateUrl: './input-search-cpf.component.html',
  styleUrls: ['./input-search-cpf.component.scss']
})
export class InputSearchCpfComponent {

  @Input() title:string;
  @Input() name:string;
  @Input() formGroup:FormGroup;
  @Input() controlName:string;

  constructor() { }

  get formControl(): AbstractControl{
    return this.formGroup.controls[this.controlName];
  }

}
